export const AVG_DAILY_TRAFFIC = 'avg_daily_traffic'
export const LAND_USE_CONTEXT = 'land_use_context'
export const ROADWAY_VARIABLES = 'roadwayVariables'
export const HIGH_CAPACITY_TRANSIT = 'high_capacity_transit'
export const PREVAILING_POSTED_SPEED = 'prevailing_posted_speed'
export const TRAVEL_LANES = 'travel_lanes'
export const ROADWAY_NAME = 'roadway_name'
export const YES = 'Yes'
export const NO = 'No'
